const printOfferModalInitialState = {
  printOfferModal: {
    isOpened: false,
    offerId: '',
    subSystemNames: [],
  },
  // Lets PrintModal drive OfferForm's active tab and tell tab components to hide interactive
  // chrome while the print flow captures each tab's DOM as an image. The targetXIndex fields
  // additionally drive nested tab strips within a tab — Sourcing's cost budgets, GCPR's
  // submissions, and PR's vendor selections are each a second, independent set of tabs nested
  // inside their parent TabPanel.
  printCapture: {
    isActive: false,
    targetTabIndex: null,
    targetCostBudgetIndex: null,
    targetGCPRSubmissionIndex: null,
    targetPRVendorSelectionIndex: null,
  },
}

const initialPrintCapture = printOfferModalInitialState.printCapture

const printOfferModalReducer = {
  showPrintOfferModal: (state, { payload }) => {
    state.printOfferModal = {
      ...payload,
      isOpened: true,
    }
  },
  hidePrintOfferModal: (state) => {
    state.printOfferModal = {
      isOpened: false,
      offerId: '',
      subSystemNames: [],
    }
  },
  startPrintCapture: (state) => {
    state.printCapture.isActive = true
  },
  stopPrintCapture: (state) => {
    state.printCapture = { ...initialPrintCapture, isActive: false }
  },
  setPrintCaptureTargetTab: (state, { payload }) => {
    state.printCapture.targetTabIndex = payload
  },
  setPrintCaptureTargetCostBudget: (state, { payload }) => {
    state.printCapture.targetCostBudgetIndex = payload
  },
  setPrintCaptureTargetGCPRSubmission: (state, { payload }) => {
    state.printCapture.targetGCPRSubmissionIndex = payload
  },
  setPrintCaptureTargetPRVendorSelection: (state, { payload }) => {
    state.printCapture.targetPRVendorSelectionIndex = payload
  },
}

const selectPrintOfferModal = (state) => state.offers.printOfferModal
const selectPrintCapture = (state) => state.offers.printCapture

export {
  printOfferModalInitialState,
  printOfferModalReducer,
  selectPrintOfferModal,
  selectPrintCapture,
}
